// extracted by mini-css-extract-plugin
export default {"bottom-sheet":"aRt7n","bottom-sheet__overlay":"WPVqq","bottom-sheet__container":"ZO35B","bottom-sheet__sticky-wrapper":"Y77lb","bottom-sheet__close":"YfsfK"};